import '../scss/main.scss';
import './modules/swiper';
import './modules/menu';
import './modules/steps';
import './modules/testimonials';
import './modules/calendar';
import './modules/accordion';
import './modules/hero';
import './modules/reveal';
import './modules/agenda';
import './modules/countdown';

// Initialize any JavaScript functionality here
document.addEventListener('DOMContentLoaded', () => {
  console.log('App initialized');
});
